import _extends from "@babel/runtime/helpers/extends";

/**@jsx jsx */
import { jsx } from '@emotion/react';
import { wrapperStyles, animatedWrapperStyles } from './styles';
import { useGlobalTheme } from '@atlaskit/theme/components';
export const Wrapper = props => {
  const theme = useGlobalTheme();
  return jsx("div", _extends({
    css: wrapperStyles({
      dimensions: props.dimensions,
      theme: theme
    })
  }, props), props.children);
};
export const AnimatedWrapper = props => {
  const theme = useGlobalTheme();
  return jsx("div", _extends({
    css: animatedWrapperStyles({
      dimensions: props.dimensions,
      theme: theme
    })
  }, props), props.children);
};